var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('v-icon',{staticClass:"icon-btn",attrs:{"color":"primary","small":""},on:{"click":function($event){$event.stopPropagation();_vm.show = true}}},[_vm._v("\n    visibility_off\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd81f602","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/HiddenText.vue
// module id = null
// module chunks = 